import React from 'react';
import { Box, Button, Tooltip, IconButton, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { addButton, container } from './styles';
import { SearchInfoComponent } from './top-info';
import { PlacesComponent } from './places';
import { useTranslation } from 'src/text';
import { useReports } from './reports-context';

const ReportsContainer: React.FC = () => {
  const { callReportApi, isLoading } = useReports();

  const { reportLabels } = useTranslation();
  return (
    <Box sx={container}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          columnGap: 1,
          mt: 8,
          mb: 4,
        }}>
        <Typography variant="h4">{reportLabels.generate}</Typography>
        <Tooltip title={reportLabels.info} placement="right" arrow>
          <IconButton size="small" aria-label="About reports">
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <PlacesComponent />
      <SearchInfoComponent />

      <Button disabled={isLoading} onClick={callReportApi} sx={addButton}>
        {reportLabels.generate}
      </Button>
    </Box>
  );
};

export { ReportsContainer };
